export const inputRules = (selector, { paddingLeft = 16, paddingRight = 16 } = {}) => `
${selector} {
  width: 100%;
  height: 50px;
  padding: 0 ${paddingRight}px 0 ${paddingLeft}px;
  background: var(--na-input-bg);
  border: 1px solid var(--na-border);
  border-radius: 10px;
  color: var(--na-ink);
  font-family: inherit;
  font-size: 16px;
  outline: none;
  transition: border-color 0.2s, box-shadow 0.2s;
}
${selector}::placeholder { color: var(--na-placeholder); }
${selector}:focus { border-color: var(--na-focus-border); box-shadow: 0 0 0 3px var(--na-focus-ring); }
${selector}:-webkit-autofill,
${selector}:-webkit-autofill:hover {
  -webkit-text-fill-color: var(--na-ink);
  caret-color: var(--na-ink);
  -webkit-box-shadow: 0 0 0 1000px var(--na-input-bg) inset;
  transition: background-color 9999s ease-out 0s;
}
${selector}:-webkit-autofill:focus {
  -webkit-text-fill-color: var(--na-ink);
  -webkit-box-shadow: 0 0 0 1000px var(--na-input-bg) inset, 0 0 0 3px var(--na-focus-ring);
}
`

export const primaryButtonRules = (selector) => `
${selector} {
  width: 100%;
  height: 50px;
  display: flex;
  align-items: center;
  justify-content: center;
  background: var(--na-primary);
  color: var(--na-on-primary);
  border: none;
  border-radius: 10px;
  font-family: inherit;
  font-size: 16px;
  font-weight: 600;
  text-decoration: none;
  cursor: pointer;
  transition: background 0.2s;
}
a${selector} { line-height: 50px; }
${selector}:hover:not(:disabled) { background: var(--na-primary-hover); }
${selector}:focus-visible { outline: 2px solid var(--na-link); outline-offset: 2px; }
${selector}:disabled { opacity: 0.7; cursor: not-allowed; }
`

export const focusOutlineRules = (selector) => `
${selector}:focus-visible { outline: 2px solid var(--na-link); outline-offset: 2px; border-radius: 4px; }
`
